import createReducer from '@monorepo/core/utils/createReducer'
import { initialState } from 'App/data/menu'

export const menuReducer = createReducer({ data: initialState }, {})
